var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoudSpeaker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#loud_speaker_svg__clip0_8610_4172)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.437.1A1 1 0 0112 1v18a1 1 0 01-1.618.786L4.291 15H1a1 1 0 01-1-1V6a1 1 0 011-1h3.29L10.383.214A1 1 0 0111.437.1zM10 3.058l-4.746 3.73A1 1 0 014.636 7H2v6h2.636a1 1 0 01.618.214L10 16.942V3.057zm5.293.236a1 1 0 011.414 0l.343.343a9 9 0 010 12.728l-.343.343a1 1 0 01-1.414-1.414l.343-.343a7 7 0 000-9.9l-.343-.343a1 1 0 010-1.414zm-2 3a1 1 0 011.414 0l.172.171a5 5 0 010 7.072l-.172.171a1 1 0 01-1.414-1.414l.171-.172a3 3 0 000-4.242l-.171-.172a1 1 0 010-1.414z",
    fill: "#333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "loud_speaker_svg__clip0_8610_4172"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}

export default SvgLoudSpeaker;